import { PRESET_HOUSEHOLDS, type HouseholdPreset } from "../utils/presetHouseholds";
import { cn } from "@/lib/utils";

interface PresetPickerProps {
  selectedId: string | null;
  onSelect: (preset: HouseholdPreset) => void;
}

export default function PresetPicker({ selectedId, onSelect }: PresetPickerProps) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      {PRESET_HOUSEHOLDS.map((p) => {
        const active = selectedId === p.id;
        return (
          <button
            key={p.id}
            type="button"
            onClick={() => onSelect(p)}
            className={cn(
              "text-left rounded-xl border p-4 transition-all hover-scale flex flex-col h-full",
              "focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2",
              active
                ? "border-primary bg-primary/5 shadow-sm"
                : "border-border bg-card hover:border-primary/40",
            )}
            aria-pressed={active}
          >
            <div className="text-sm font-semibold mb-1">{p.label}</div>
            <div className="text-xs text-muted-foreground leading-snug">{p.blurb}</div>
            <div className="text-[10px] uppercase tracking-wide text-muted-foreground/70 mt-auto pt-2">
              {p.items.length} items
            </div>
          </button>
        );
      })}
    </div>
  );
}
